export const iconBlue = 'hsl(191deg 100% 42%)';

// Source:
// https://v3.tailwindcss.com/docs/customizing-colors

export const slate50 = '#f8fafc';
export const slate100 = '#f1f5f9';
export const slate200 = '#e2e8f0';
export const slate300 = '#cbd5e1';
export const slate400 = '#94a3b8';
export const slate500 = '#64748b';
export const slate600 = '#475569';
export const slate700 = '#334155';
export const slate800 = '#1e293b';
export const slate900 = '#0f172a';
export const slate950 = '#020617';

export const red50 = '#fef2f2';
export const red100 = '#fee2e2';
export const red200 = '#fecaca';
export const red300 = '#fca5a5';
export const red400 = '#f87171';
export const red500 = '#ef4444';
export const red600 = '#dc2626';
export const red700 = '#b91c1c';
export const red800 = '#991b1b';
export const red900 = '#7f1d1d';
export const red950 = '#450a0a';

export const green50 = '#f0fdf4';
export const green100 = '#dcfce7';
export const green200 = '#bbf7d0';
export const green300 = '#86efac';
export const green400 = '#4ade80';
export const green500 = '#22c55e';
export const green600 = '#16a34a';
export const green700 = '#15803d';
export const green800 = '#166534';
export const green900 = '#14532d';
export const green950 = '#052e16';
